import getShouldHideForCategory
from '../../../v2/selectors/PaymentOptionSelectors/ApmExperimentSelectors/getShouldHideForCategory';
import getShouldHideIfGiftcardApplied
from '../../../v2/selectors/PaymentOptionSelectors/ApmExperimentSelectors/getShouldHideIfGiftcardApplied';
import categories from './paymentOptionCategories';
import getIcon from './paymentOptionSvgs';

export default (paymentOption, shortName) => ({
  shortName,
  title: `checkout.payment.category.${categories[shortName]}`,
  icons: getIcon(shortName),
  useFullSizeIconsInArray: false,
  useInitialHeight: false,
  iconTitle: 'checkout.payment.method.field.label.pay.with.icon.alt',
  paymentName: `checkout.payment.method.${shortName.replace(/_/g, '.').toLowerCase()}.name`,
  inputId: `pay-with-${shortName}`,
  imgId: `${shortName}-logo`,
  paymentOptionContents: null,
  getIsDisabled: () => false,
  getMessage: () => null,
  getShouldHide: () => false,
  getShouldHideForCategory: () => getShouldHideForCategory(paymentOption.name),
  getShouldHideIfGiftcardApplied: () => getShouldHideIfGiftcardApplied(paymentOption.name),
});
